// src/constants/taskStatus.js
export const TASK_STATUS = {
    PLAN: 'P',
    VALID: "V",   
    INVALID: 'I', 
    CREATED: 'C',     
    REJECTED: 'RJ',
    REQUEST: 'R',
};
